import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const summaryRowStyle = () => ({
	summaryRowWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
		padding: '3px 0',
		'& > div': {
			'& > p': {
				marginBottom: 0,
			},
			'&:last-of-type': {
				display: 'flex',
				alignItems: 'center',
				'& svg': {
					color: blackColors[4],
					marginRight: '8px',
					position: 'relative',
					bottom: '3px',
				},
				'& p': {
					textAlign: 'right',
				},
			},
		},
	},
	withBorder: {
		borderBottom: `1px solid ${blackColors[6]}`,
	},
});

export default summaryRowStyle;
